module.exports = __webpack_public_path__ + "img/feature_buy_en.43c563b0.png";